import styled from 'styled-components';

export const StyledIframe = styled.iframe`
  margin: auto;
  display: block;
`;
export const TutorialItemContent = styled.div`
  margin: 2rem 0 0 0;
`;
